module.exports = __webpack_public_path__ + "img/Bus.8ff9f2ee.png";